import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import HotelsPage from "@/pages/HotelsPage";
import HotelDetail from "@/pages/HotelDetail";
import DestinationsPage from "@/pages/DestinationsPage";
import DestinationDetail from "@/pages/DestinationDetail";
import OperatorsPage from "@/pages/OperatorsPage";
import OperatorDetail from "@/pages/OperatorDetail";
import GuidesPage from "@/pages/GuidesPage";
import GuideDetail from "@/pages/GuideDetail";
import AboutPage from "@/pages/AboutPage";
import MethodologyPage from "@/pages/MethodologyPage";
import LegalPage from "@/pages/LegalPage";
import GoPage from "@/pages/GoPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/context/AuthContext";

function SiteLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen bg-sand">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/go" element={<GoPage />} />
              <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
              <Route path="/hotels" element={<Navigate to="/operators" replace />} />
              <Route path="/hotels/:id" element={<SiteLayout><HotelDetail /></SiteLayout>} />
              <Route path="/destinations" element={<SiteLayout><DestinationsPage /></SiteLayout>} />
              <Route path="/destinations/:key" element={<SiteLayout><DestinationDetail /></SiteLayout>} />
              <Route path="/operators" element={<SiteLayout><OperatorsPage /></SiteLayout>} />
              <Route path="/operators/:key" element={<SiteLayout><OperatorDetail /></SiteLayout>} />
              <Route path="/guides" element={<SiteLayout><GuidesPage /></SiteLayout>} />
              <Route path="/guides/:slug" element={<SiteLayout><GuideDetail /></SiteLayout>} />
              <Route path="/methodology" element={<SiteLayout><MethodologyPage /></SiteLayout>} />
              <Route path="/legal" element={<SiteLayout><LegalPage /></SiteLayout>} />
              <Route path="/privacy" element={<Navigate to="/legal#privacy" replace />} />
              <Route path="/terms" element={<Navigate to="/legal#terms" replace />} />
              <Route path="/about" element={<SiteLayout><AboutPage /></SiteLayout>} />
              <Route path="/_browse" element={<SiteLayout><HotelsPage /></SiteLayout>} />
              <Route path="*" element={<SiteLayout><NotFound /></SiteLayout>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
